import { ResponsiveBehaviour } from "../utilities/ResponsiveBehaviour.js";
import { MenuDesktop } from "./MenuDesktop.js";
import { MenuMobile } from "./MenuMobile.js";


/**
 * Class to implement the menu functionality
 * for a single instance; the application is
 * done via the MenuManager class
 */
export class Menu extends ResponsiveBehaviour
{
    private static readonly BREAKPOINT: number = 1440;

    /**
     * Constructor of the Menu
     *
     * @param {HTMLElement} menu
     */
    public constructor(menu: HTMLElement)
    {
        super();

        // Register the mobile menu
        this.register(0, new MenuMobile(menu));

        // Register the desktop menu
        this.register(Menu.BREAKPOINT, new MenuDesktop(menu));

        // Watch for viewport changes
        this.watch();
    }
}
